var map = {
	"./angle.svg": 86,
	"./arrow-left.svg": 87,
	"./arrow-right.svg": 88,
	"./book-open.svg": 89,
	"./carousel-arrow.svg": 90,
	"./chevron.svg": 91,
	"./clock.svg": 92,
	"./cross.svg": 93,
	"./download.svg": 94,
	"./facebook.svg": 95,
	"./google.svg": 96,
	"./heart-left.svg": 97,
	"./heart-right.svg": 98,
	"./home.svg": 99,
	"./instagram.svg": 100,
	"./letter.svg": 101,
	"./linkedin.svg": 102,
	"./localisation.svg": 103,
	"./mail.svg": 104,
	"./marker.svg": 105,
	"./menu.svg": 106,
	"./pinterest.svg": 107,
	"./play-rounded.svg": 108,
	"./plus.svg": 109,
	"./quote.svg": 110,
	"./star.svg": 111,
	"./tiktok.svg": 112,
	"./triangle.svg": 113,
	"./twitter.svg": 114,
	"./user.svg": 115,
	"./youtube.svg": 116,
	"./zoom.svg": 117
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85;